"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTPPSalesReport = exports.getOrderSalesReport = exports.getActualQuarterSalesReport = exports.getActualMonthSalesReport = exports.default = void 0;
var _request = _interopRequireDefault(require("@/http/request"));
/**
 * 门店报表
 */
/** package */

// 2.1. (Q_TPPSales)TPP达成量
var getTPPSalesReport = exports.getTPPSalesReport = function getTPPSalesReport(data, cancelToken) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/app/store/report/tpp/sales",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// 2.2. (Q_ActualSalesMonth)月度实际销售量
var getActualMonthSalesReport = exports.getActualMonthSalesReport = function getActualMonthSalesReport(data, cancelToken) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/app/store/report/actual/sales/month",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// 2.3. (Q_ActualSalesQuarter)季度实际销售量
var getActualQuarterSalesReport = exports.getActualQuarterSalesReport = function getActualQuarterSalesReport(data, cancelToken) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/app/store/report/actual/sales/quarter",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// 2.4. (Q_OrderSales)月度订单销售量
var getOrderSalesReport = exports.getOrderSalesReport = function getOrderSalesReport(data, cancelToken) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/app/store/report/order/sales",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};
var _default = exports.default = {
  getTPPSalesReport: getTPPSalesReport,
  getActualMonthSalesReport: getActualMonthSalesReport,
  getActualQuarterSalesReport: getActualQuarterSalesReport,
  getOrderSalesReport: getOrderSalesReport
};